/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_Auto_OffInputs */

const cs_gdpr_review_auto_off = /** @type {(inputs: Gdpr_Review_Auto_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatická anonymizace je vypnutá.`)
};

const en_gdpr_review_auto_off = /** @type {(inputs: Gdpr_Review_Auto_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic anonymisation is off.`)
};

/**
* | output |
* | --- |
* | "Automatic anonymisation is off." |
*
* @param {Gdpr_Review_Auto_OffInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_auto_off = /** @type {((inputs?: Gdpr_Review_Auto_OffInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_Auto_OffInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_auto_off(inputs)
	return cs_gdpr_review_auto_off(inputs)
});